'use strict';

const switchTokens = (theme) => ({
    switchToggleSize: '1rem',
    switchToggleBackground: theme.colors.body.background,
    switchToggleContainerOffset: `${2 / 16}rem`,
    switchMinWidth: `${44 / 16}rem`,
    switchRadius: theme.typography.lineHeight.s,
    switchLineHeight: theme.typography.lineHeight.s,
    switchTextColor: theme.colors.body.background,
    switchTextPaddingX: theme.space.component.x.s,
    switchFocusShadow: `0 0 0 ${theme.space.component.x.xs} ${theme.palette.blue400Alpha}`,
    switchBackgroundColor: theme.palette.grey400,
    switchDisabledBackgroundColor: theme.palette.grey200,
    switchCheckedBackgroundColor: theme.colors.primary.normal,
    switchCheckedDisabledBackgroundColor: theme.palette.blue200,
    switchCheckUncheckTransition: `${theme.transition.timings.fast} ${theme.transition.functions.easeFn}`,
});

exports.switchTokens = switchTokens;
//# sourceMappingURL=switch.js.map
